<template>
  <div class="relevance" v-if="!loading">
    <div class="box">
      <xm-page v-if="courseList.length">
        <xm-page-content>
          <xm-scroll
            v-if="courseList.length"
            :on-infinite="onInfinite"
            :on-refresh="onRefresh"
            :enableInfinite="hasMoreCourse"
          >
            <ul class="mall-list">
              <li
                v-for="(item, index) in courseList"
                :key="index"
                class="item"
                @click="jumpToCourse(item.id)"
              >
                <div class="detail">
                  <img
                    :src="(item.coverResource || {}).resUrl || 'https://image.xiaomaiketang.com/xm/kNYEN5Qiw6.png'"
                    class="image"
                    alt
                  />
                  <span class="title">{{item.commodityName}}</span>
                  <span class="price">¥{{moneyFormatGroup(item.commodityPrice, 2)}}</span>
                </div>
              </li>
            </ul>
          </xm-scroll>
          <div class="micro-entry-box" @click="handleLinkToMicroSite">
            <div class="micro-entry">
              <img src="https://image.xiaomaiketang.com/xm/d72h2iH5H7.png" alt="机构微官网图片">
            </div>
          </div>

          <micro-site-modal
            v-if="modalVisible"
            :data="{
            currentXcxCodeUrl:this.currentXcxCodeUrl,
            currentItem:{},
            fromOrigin:'product-list',
            close:this.closeMicroSiteModal
          }"
          />
        </xm-page-content>
      </xm-page>

      <xm-empty-page v-else title="暂无商品" :src="emptyCourse" :onLoading="reload"></xm-empty-page>
    </div>
  </div>
</template>

<script>
import { moneyFormatGroup } from "../../core/filters";
import EmptyDataPage from "@/module/base/EmptyDataPage";
import emptyCourse from "@/images/no_message_schedule.png";
import emptyOrder from "@/images/no_consume.png";
import User from "@/core/user";
import WechatApi from "@/core/wechatApi";
import MicroSiteModal from "../../components/MicroSiteModal";
import InstService from "@/service/InstitutionService";

export default {
  components: {
    xmEmptyPage: EmptyDataPage,
    "micro-site-modal": MicroSiteModal
  },

  data() {
    return {
      status: "mall",
      courseList: [],
      orderList: [],
      reload: false,
      emptyCourse,
      emptyOrder,
      courseQuery: {
        current: 1,
        size: 20
      },
      courseTotal: 0,
      orderQuery: {
        current: 1,
        size: 20
      },
      orderTotal: 0,
      moneyFormatGroup,
      hasMoreCourse: true,
      hasMoreOrder: true,
      loading: true,
      marketingStatus: false, // 微官网关联入口开启状态
      modalVisible: false, // 微官网太阳码模态框
      currentXcxCodeUrl: null,
      inst:{
        instName:"",
        banner:""
      }
    };
  },

  methods: {
    closeMicroSiteModal(){
      this.modalVisible = false;
    },
    handleLinkToMicroSite() {
      const instId = window.getParameterByName("mallInstId");
      InstService.getMarketingStatus({
        instId
      }).then(res => {
        this.marketingStatus = res.result;
        if (this.marketingStatus) {
          this.modalVisible = true;
          const params = {
            scene: JSON.stringify({ instId })
          };
          let serverPath = drServer || window.CONFIG.server;
          if (SERVER) {
            serverPath = drServer || SERVER;
          }
          InstService.generateCodeUrl(params).then(res => {
            const currentXcxQrcode = `${SERVER || window.CONFIG.server}sales/anon/commonMicroWebsite/getXcxCode?scene=${res.result}`;
            this.currentXcxCodeUrl = currentXcxQrcode;
          });
        } else {
          window.router.push({
            name: "inst_home",
            query: { id: instId, fromP: true }
          });
        }
      });
    },
    fetchCourseList(current = 1, done) {
      if (
        (current - 1) * this.courseQuery.size > this.courseTotal &&
        this.courseTotal
      ) {
        this.hasMoreCourse = false;
        done && done();
        return;
      }
      const data = {
        ...this.courseQuery,
        instId: window.getParameterByName("mallInstId"),
        current
      };
      axios.Customer("public/courseCommodity/queryOnePage", data).then(res => {
        if (res.success) {
          this.courseList =
            current > 1
              ? this.courseList.concat(res.result.records)
              : res.result.records;
          this.loading = false;
          this.courseTotal = res.result.total;
          this.courseQuery = { ...this.courseQuery, current };
          this.hasMoreCourse = res.result.hasNext;
          done && done();
        }
      });
    },

    fetchOrderList(current = 1, done) {
      if (
        (current - 1) * this.orderQuery.size > this.orderTotal &&
        this.orderTotal
      ) {
        this.hasMoreOrder = false;
        done && done();
        return;
      }
      const data = {
        ...this.orderQuery,
        userId: User.uid(),
        studentId: window.getParameterByName("studentId"),
        current
      };
      axios.Customer("public/customerOrder/queryOnePage", data).then(res => {
        if (res.success) {
          this.orderList =
            current > 1
              ? this.orderList.concat(res.result.records)
              : res.result.records;
          this.orderTotal = res.result.total;
          this.orderQuery = { ...this.orderQuery, current };
          this.hasMoreOrder = res.result.hasNext;
          done && done();
        }
      });
    },

    onRefresh(done) {
      if (this.status == "mall") {
        this.fetchCourseList(1, done);
      } else {
        this.fetchOrderList(1, done);
      }
    },

    onInfinite(done) {
      if (this.status == "mall") {
        this.fetchCourseList(this.courseQuery.current + 1, done);
      } else {
        this.fetchOrderList(this.orderQuery.current + 1, done);
      }
    },

    changeTab(status) {
      this.status = status;
    },

    jumpToCourse(id) {
      this.$router.push({
        name: "commodity_detail",
        query: {
          mallInstId: window.getParameterByName("mallInstId"),
          studentId: window.getParameterByName("studentId"),
          commodityId: id
        }
      });
    },

    jumpUrl(orderId) {
      var flag = User.appId() != (APPID || "wxdd6b458500d4c224");
      let componentId = "wx34b8ca68dd4886db";
      if (location.host.indexOf("rc.xiaomai5") != -1) {
        componentId = "wxa56549a4098a9d32";
      }
      const host = `${window.CONFIG.payHost()}#/mallPay?orderId=${orderId}&xmToken=${User.token()}&userId=${User.uid()}&openId=${User.openId()}&appId=${APPID}&instId=${window.getParameterByName(
        "mallInstId"
      )}`;
      let reloadUrl = "";
      if (flag) {
        reloadUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${User.appId()}&redirect_uri=${encodeURIComponent(
          host
        )}&component_appid=${componentId}&response_type=code&scope=snsapi_base#wechat_redirect`;
      } else {
        reloadUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${User.appId()}&redirect_uri=${encodeURIComponent(
          host
        )}&response_type=code&scope=snsapi_base&state=state#wechat_redirect`;
      }
      return reloadUrl;
    },

    jumpToOrder(id) {
      window.location.href = this.jumpUrl(id);
    },

    doShare() {
      const list = User.getInstList();
      const inst = _.find(
        list,
        item => item.instId == window.getParameterByName("mallInstId")
      );
      inst &&
        WechatApi.doWapShare({
          title: `${inst.instName}有购课商城啦！`,
          desc: "线上购课，微信支付，免去排队烦恼，快来看看~~",
          linkUrl:
            location.origin +
            location.pathname +
            "#/mall/buyer?appid=" +
            User.appId() +
            "&mallInstId=" +
            inst.instId,
          imgUrl:
            inst.banner || "https://image.xiaomaiketang.com/xm/fpnxF7Gbmt.png"
        });
      inst && wx.miniProgram.postMessage({ data: {
        title: `${inst.instName}有购课商城啦！`,
          desc: "线上购课，微信支付，免去排队烦恼，快来看看~~",
          linkUrl:
            location.origin +
            location.pathname +
            "#/mall/buyer?appid=" +
            User.appId() +
            "&mallInstId=" +
            inst.instId,
          imgUrl:
            inst.banner || "https://image.xiaomaiketang.com/xm/fpnxF7Gbmt.png"
      } })
    }
  },
  mounted() {
    this.fetchCourseList();
    this.fetchOrderList();
    this.doShare();
    wx.hideMenuItems({
      menuList: ["menuItem:copyUrl"] // 要显示的菜单项，所有menu项见附录3
    });
  }
};
</script>


 <style lang="less">
@import "../../core/variables.less";
@import "../../core/mixins.less";
.relevance {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  .tab {
    height: 0.96rem;
    background: #fff;
    border-bottom: 1px solid #eee;
    display: flex;
    .tab-item {
      position: relative;
      width: 50%;
      text-align: center;
      font-size: 0.3rem;
      line-height: 0.96rem;
      color: #333;
      &.selected {
        color: #3296fa;
        &::after {
          position: absolute;
          content: "";
          width: 0.4rem;
          height: 1px;
          background: #3296fa;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
  }
  .box {
    width: 100vw;
    height: ~"calc(100vh - 0.96rem)";
    position: relative;
    .mall-list {
      background: #fff;
      .item {
        padding: 0.2rem 0.32rem 0;
        height: 2rem;
        .detail {
          width: 100%;
          height: 100%;
          border-bottom: 1px solid #eee;
          position: relative;
          .image {
            width: 1.6rem;
            height: 1.6rem;
            position: absolute;
            left: 0.06rem;
            top: 0;
            object-fit: cover;
          }
          .title {
            position: absolute;
            top: 0;
            left: 1.84rem;
            width: ~"calc(100vw - 2.52rem)";
            height: 0.84rem;
            overflow: hidden;
            color: #333;
            font-size: 0.3rem;
            line-height: 0.42rem;
          }
          .price {
            position: absolute;
            left: 1.84rem;
            bottom: 0.2rem;
            font-size: 0.3rem;
            color: #ff8534;
            line-height: 0.42rem;
            width: ~"calc(100vw - 2.52rem)";
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        &:last-child {
          .detail {
            border: none;
          }
        }
      }
    }
    .order-list {
      .item {
        background: #fff;
        margin-top: 0.2rem;
        padding: 0 0.32rem;
        .detail {
          padding: 0.2rem 0;
          display: flex;
          border-bottom: 1px solid #eee;
          .image {
            width: 1.6rem;
            height: 1.6rem;
            margin-right: 0.3rem;
            object-fit: cover;
          }
          .info {
            height: 1.6rem;
            width: ~"calc(100% - 1.9rem)";
            position: relative;
            .name {
              display: flex;
              justify-content: space-between;
              align-items: center;
              .title {
                font-size: 0.3rem;
                line-height: 0.42rem;
                margin-right: 0.2rem;
                color: #333;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .tag {
                width: 0.82rem;
                height: 0.32rem;
                border-radius: 0.04rem;
                line-height: 0.32rem;
                text-align: center;
                color: #fff;
                font-size: 0.22rem;
                flex-shrink: 0;
                &.to-be-paid {
                  background: #ffba43;
                }
                &.paid {
                  background: #3bbdaa;
                }
                &.cancelled {
                  background: #cccccc;
                }
              }
            }
            .unit {
              position: absolute;
              width: 100%;
              bottom: 0;
              display: flex;
              justify-content: space-between;
              font-size: 0.3rem;
              line-height: 0.42rem;
              .number {
                color: #999;
              }
              .price {
                color: #ff8534;
              }
            }
          }
        }
        .inst {
          height: 0.8rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .name {
            width: 72%;
            display: flex;
            align-items: center;
            .icon {
              margin-right: 0.1rem;
              font-size: 0.3rem;
              color: #999999;
            }
            .word {
              font-size: 0.26rem;
              color: #999999;
              flex-shrink: 0;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              width: ~"calc(100% - 0.5rem)";
            }
          }
          .student {
            max-width: 24%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 0.26rem;
            height: 0.42rem;
            color: #999999;
          }
        }
      }
    }
  }
    .micro-entry-box {
      position: fixed;
      bottom: 3.8rem;
      right: 0.2rem;
      z-index: 1001;
      .micro-entry {
        width: 1.16rem;
        height: 1.16rem;
        border-radius: 50%;
        z-index: 10001;
        img {
          width: 1.16rem;
          height: 1.16rem;
        }
      }
  }
}
</style>





// WEBPACK FOOTER //
// src/module/mall/CourseMall.vue